import * as S from "effect/Schema";
/**
 * Offset pagination fields shared by every list intent on this contract —
 * merge into a per-intent params struct with `S.extend` alongside that
 * intent's own filter fields (the `SharesForUserParams` shape, factored out
 * once a second list intent needed the same limit/offset/default rule).
 */
export const PagingParams = S.Struct({
    limit: S.optionalWith(S.NumberFromString.pipe(S.int(), S.between(1, 100)), {
        default: () => 20,
    }),
    offset: S.optionalWith(S.NumberFromString.pipe(S.int(), S.greaterThanOrEqualTo(0)), { default: () => 0 }),
});
/** The `{ items, total }` success shape every paged list intent returns. */
export const pagedResponse = (item) => S.Struct({ items: S.Array(item), total: S.Int });
//# sourceMappingURL=paging.js.map